<template>
  <div>
    <PageHeaderLayout :isBack="true">
        <div class="main-page-content" id="send-content">
          <el-row>
            <div class="header-title">结算审批</div>
          </el-row>
          <!-- <el-row class="center">
              <el-col :span="10">
                <p class="title text-center">{{ this.baseInfo.name }}</p>
                <el-alert class="desc" type="warning" :closable="false" id="el-alert">
                  <template slot="title">
                    <div>系统提示：</div>
                    <div>1、单个批次模板数据不能超过1000条</div>
                    <div v-if="type == 'send'">2、如果需要提交数据请滑动最底部点击按钮</div>
                  </template>
                </el-alert>
              </el-col>
            </el-row> -->
            <el-row class="detail-top">
              <!-- <el-col :span="15" class="detail-search">
                <el-form size="medium" :inline="true" :model="searchCondition">
                  <el-form-item label="姓名">
                    <el-input v-model="searchCondition.fullname" placeholder="输入姓名" class="item-name" clearable></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="searchButton">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col> -->
              <el-col class="total-wrapper">
                <div class="total-left">总笔数：</div>
                <div class="total-right">{{ totalNum }}
                  <span class="total-right bi">笔</span>
                </div>
              </el-col>
              <el-col class="total-wrapper">
                <div class="total-left">总金额：</div>
                <div class="total-right">{{ totalMoney }}
                  <span class="total-right bi">元</span>
                </div>
              </el-col>
              <el-col class="table-right">
                <el-select v-model="value" @change="selectData" class="select-box">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-button :loading="downloadLoading" type="primary" class="export-table" size="medium" icon="el-icon-document" @click="handleDownload">
                  导出
                </el-button>
              </el-col>
            </el-row>
            <el-row  id="send-table">
              <ApeTable ref="sendapeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
              </ApeTable>
            </el-row>
            <el-row v-if="type == 'send'" class="center">
              <el-col class="text-center" :span="10">
                <el-button type="primary" size="medium" @click="handleSubmit">请仔细检查数据，确认无误后提交此表格</el-button>
              </el-col>
            </el-row>
        </div>
    </PageHeaderLayout>
    <verification
      @dialogChanged="dialogChanged($event)"
      @onSuccess="handleSuccess($event)"
      :dialogVisible="dialogVisible" 
      :mobile="mobile"
      />
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import Verification from "@/components/Verification"
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    Verification
  },
  data() {
    return {
      isLaowuCompany:false,
      isNext:true,
      mobile: '',
      dialogVisible: false,
      id: 0,
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      type: '',
      totalPrice: '',
      tableHeader: [],
      searchCategory: [],
      taskList: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: true,
      idcard: '',
      isSign: false,
      //导出格式
      options: [{
          value: 'xlsx',
          label: 'xlsx'
        }, {
          value: 'csv',
          label: 'csv'
        }, {
          value: 'txt',
          label: 'txt'
        }
      ],
      value: 'xlsx',
      //导出表格类型
      bookType: 'xlsx',
      columns: [
        {
          title: "姓名",
          value: "bank_account_name"
        },
        {
          title: "身份证号码",
          value: "id_number",
        },
        {
          title: "手机号码",
          value: "mobile",
        },
        {
          title: "收款账号",
          value: "bank_account_no"
        },
        {
          title: "结算金额",
          value: "money",
        },
        {
          title: "实收金额",
          value: "after_money",
        },
        {
          title: "个税",
          value: "now_tax_money",
        },
		{
		title: "预扣增值税和附加税",
		value: "added_tax_money",
		header_align: "center",
		align: "center",
		width: 180,
		},
        {
          title: "银行名称",
          value: "bank_name",
        },
        {
          title: "开户行名称",
          value: "bank_branch"
        },
        {
          title: "编码",
          value: "code",
        },
        {
          title: "下发通道",
          value: "send_type",
        },
        {
          title: "上传时间",
          value: "created_at",
        },
      ],
      columns_laowu: [
        {
          title: "姓名",
          value: "bank_account_name"
        },
        {
          title: "身份证号码",
          value: "id_number",
        },
        {
          title: "手机号码",
          value: "mobile",
        },
        {
          title: "收款账号",
          value: "bank_account_no"
        },
        {
          title: "实收金额",
          value: "money",
        },
        {
          title: "银行名称",
          value: "bank_name",
        },
        {
          title: "开户行名称",
          value: "bank_branch"
        },
        {
          title: "编码",
          value: "code",
        },
        {
          title: "下发通道",
          value: "send_type",
        },
        {
          title: "上传时间",
          value: "created_at",
        },
      ],
      // 表格列表数据
      baseInfo:{},
      dataList:[],
      //导出表格数据
      exportList: [],
      downloadLoading: false,
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, prev, pager, next',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证

      // 抽屉数据，附件列表
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        // direction: 'right',
        title: '',
        width_height: '640px',
        show_footer:false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 附件列表
      attachmentList:[],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: '标题',
          value: 'title',
        }
      ],
      // 添加附件
      dialogData:{
        visible: false,
        title: '',
        width: '24%',
        loading: true,
        modal: false
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
      // 当前需要操作附件的文章id
      currentCompanyId:0,
      totalNum: 0,
      totalMoney: 0
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    // totalNum: function() {
    //   return (this.dataList.length)
    // },
    // totalMoney: function() {
    //   return 1
    // },
  },
  methods: {
    async handleSuccess() {
      const res = await this.$api.sendTask({
        batch_id: this.baseInfo.id,
      })
      if (res) {
        this.$message.success('提交成功，请等待系统审核!')
        this.goBack()
      }
      console.log("handleSuccess")
    },
    //返回上一页
    goBack() {
      this.$router.push(this.$route.matched[1].path)
    },
    dialogChanged(state) {
      this.dialogVisible = state
    },
    // 表单提交
    handleSubmit() {
      if(this.isNext == false){
        this.$message({
            message: '请补充完整风控表信息，再进行下发操作',
            type: 'warning'
        })
        return false
      }

      if (this.dataList.length <= 0) {
        return this.$message.error('提交失败，数据不能为空!')
      }
      this.dialogVisible = true;
      this.getStaffAudit()
    },
    //获取审核人员手机号
    async getStaffAudit() {
      let result = await this.$api.getStaffAudit()
      if(result) {
        this.mobile = result.mobile
      }
    },
     // 搜索
    searchButton() {
      this.init()
    },
    //选择导出表格格式
    selectData(e) {
      this.bookType = e;
    },

    // 切换页码操作
    async switchPaging() {
      this.init()
    },

    //导出表格数据
    async handleDownload() {
      this.downloadLoading = true
      import('@/excel/Export2Excel').then( excel => {
        let tHeader = ['姓名', '收款账号', '下发通道', '证件类型', '证件号码', '手机号码', '结算金额','实收金额','个税','预扣增值税和附加税', '开户行名称', '编码', '上传时间'];
        if(this.isLaowuCompany){
          tHeader = ['姓名', '收款账号', '下发通道', '证件类型', '证件号码', '手机号码', '实收金额', '开户行名称', '编码', '上传时间'];
        }
        const data = this.formatJson(this.exportList)
        const time = new Date().getTime() + Math.random() * 1000
        let filename = `审批任务${time}`
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType //Optional
        })
        this.downloadLoading = false;
      })
    },
    formatJson(jsonData) {
      return jsonData.map(v =>{
        let {
          bank_account_name,
          bank_account_no,
          send_type,
          id_type,
          id_number,
          mobile,
          money,
          after_money,
          now_tax_money,
		added_tax_money,
          bank_branch,
          code,
          created_at
        } = v
        if(this.isLaowuCompany){
          return [bank_account_name, bank_account_no, send_type, id_type, id_number, mobile, money, bank_branch, code, created_at]
        }else{
          return [bank_account_name, bank_account_no, send_type, id_type, id_number, mobile, money,after_money,now_tax_money,added_tax_money, bank_branch, code, created_at]
        }
      })
    },
	// 初始化列表
	async init(type) {
      var _this = this
		this.id = this.$route.params.batch_id
		if (this.id) {
			this.loadingStaus = true
			let args = {
				id: this.id
			}
        let {base, detail}= await this.$api.getTaskInfo(args)
			this.baseInfo = base
				this.dataList = detail
        this.totalNum = detail.length
        this.totalMoney = detail.reduce(function (total, currentValue) {
          return _this.$utils.sumTotal(total, currentValue.money)
        }, 0)
				this.exportList = detail
				this.idcard = detail.id_number
        let pagingInfo = this.$refs['sendapeTable'].getPagingInfo(type)
        this.pagingData.total = this.dataList.length
        this.offset += 10
        this.dataList=  this.dataList.slice(pagingInfo.current_page * 10 - 10, pagingInfo.current_page * 10)
		}
      this.loadingStaus=false
	},
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.id) {
        condition.id = this.searchCondition.id
      }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      return condition
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = '正在提交中……'
      this.dialogData.loading = true
      this.formData.company_id = this.currentCompanyId
      let id = await this.$api.saveCompanyAttachment(this.formData)
      this.$nextTick(() => {
        this.dialogClose()
      })
      this.$nextTick(() => {
        if (id) {
          this.initCompanyAttachmentList()
        }
      })
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['companyAttacmentForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.attachmentUploadFileList = []
    },
    // 响应添加附件按钮
    async addAttachment() {
      this.dialogData.visible = true
      this.dialogData.loading = false
      this.dialogData.title = '添加附件'
    },
    // 相应删除文章附件按钮
    async deleteCompanyAttachmentButton(id) {
      let info = await this.$api.deleteCompanyAttachment(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.init()
        })
      } else {
        this.$message.error(info)
      }

    },

    async getSignStatus() {
      let status = await this.$api.getTaskSign({
        idcard: '12313'
      })
      if(status == 'failed') {
        this.isSign = '未签约'
      }else {
        this.isSign = '已签约'
      }
    },
    async getCompanyInfo(){
      let {id} = this.$storage.get("nowCompany")
      let result = await this.$api.getCompanyInfo(id)
      if(result.info.risk_url){
          this.isNext = true
      }else{
          this.isNext = false
      }
    },
    // 是否是劳务公司
		async getIsLaoWu(){
			let settlementList = await this.$api.getUserSettlement({
				company_id:JSON.parse(localStorage.getItem('nowCompany')).id
			})
			// console.log(settlementList)
			let companyIds = JSON.parse(localStorage.getItem('user_info')).settlement_id.replaceAll(/"/g,'')
			let newSettlementList = Object.assign(settlementList, [])
			
			newSettlementList.map(item=>{
				if(item.id == companyIds){
				if(item.is_labor_dispatch != 0){
					this.isLaowuCompany = true
				}
				}
			})
			if(this.isLaowuCompany){
        this.columns = this.columns_laowu
      }
		},
    
  },
  updated() {
    this.type = this.mxGetQuery('type') || 'send'
    if(this.type != 'send') {
      this.$refs['sendapeTable'].handleCurrentChange(1)
    }
  },
  created() {
    // this.type = this.mxGetQuery('type') || 'send'
  },
  mounted() {
    this.getIsLaoWu()
    this.init()
    // this.getCompanyInfo()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .submitBtn
    float: right
    margin-top: 20px
  .link-url
    color: #fff
    text-decoration:none
  .title
    font-size: 32px
  .desc
    margin-bottom 30px
  .center
    display flex
    justify-content center
  .text-center
    text-align center
    margin-bottom: 20px
  .header-title
    height: 53px
    line-height: 53px
    background-color: #1890ff
    color: #fff
    font-size: 20px
    text-align: center
  #send-content
    padding: 0;
  #send-table
    padding: 0 24px
  .detail-search
    margin-left: 30px
  .total-wrapper
    display: flex
    flex-direction: row
    padding: 0 10px
    margin-top: 10px
    margin-left: 15px
    width: 270px
  .total-left
    color: #606266
    font-size: 16px
    text-align: left
  .total-right
    color: red;
    font-size: 15px
  .bi
    color: #606266
  .detail-top
    display: flex
    flex-direction: row
    justify-content: flex-end
  .table-right
    display: flex
    flex-direction: row
    justify-content: flex-end
    padding-right: 20px
  .select-box
    margin-right: 20px
    width: 100px

</style>
